import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shop-form__block" }

import { computed } from "vue";
import { useStore } from "vuex";
import {TypeLoyalityKinds} from '@/types'
import { IloyalityShopData, TypeReceiver } from "@/types/typesOfState";
import {Store} from 'vuex'



export default /*#__PURE__*/_defineComponent({
  __name: 'stepSetReceiver',
  setup(__props) {

const store = useStore()

const loyalityShopData = computed<IloyalityShopData>(() => store.state.loyalityShopData)
const currentLoyalityKind = computed<TypeLoyalityKinds>(() => store.state.currentLoyalityKind)

function setCurrentReceiver(newLoyalityKind: TypeReceiver): void {
  store.state.loyalityShopData.receiver = newLoyalityKind
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["button grey", { active: loyalityShopData.value.receiver === 'other' }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (setCurrentReceiver('other')))
    }, "В подарок", 2),
    _createElementVNode("span", {
      class: _normalizeClass(["button grey", { active: loyalityShopData.value.receiver === 'self' }]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (setCurrentReceiver('self')))
    }, "Себе", 2)
  ]))
}
}

})